import { createFileRoute, redirect } from '@tanstack/react-router';

/** 20a: there is no task list any more; every piece of work is a case. Old links land on the case list. */
export const Route = createFileRoute('/_app/tasks/')({
  beforeLoad: () => {
    throw redirect({ to: '/cases', replace: true });
  },
});
